export class FormException extends Error {
  constructor(msg: string) {
    super(msg);
  }
}
